import LaunchButton from "@/components/LaunchButton"
import TextInput from "@/components/text-input"
import { faCamera, faMagnifyingGlass, faWandMagicSparkles } from "@fortawesome/free-solid-svg-icons"

type PhysicalRiskDescriptionStartMode = "catalog" | "describe" | "photo"

interface Props {
  description: string
  descriptionPlaceholder: string
  isChoiceVisible: boolean
  isPopulationPerimeter: boolean
  onDescriptionChange: (value: string) => void
  onSelectMode: (mode: PhysicalRiskDescriptionStartMode) => void
}

export default function PhysicalRiskSelectStep({
  description,
  descriptionPlaceholder,
  isChoiceVisible,
  isPopulationPerimeter,
  onDescriptionChange,
  onSelectMode
}: Props) {
  return (
    <div className="flex flex-1 flex-col">
      {isChoiceVisible ? (
        <div className="m-auto flex w-full max-w-[700px] gap-20">
          <LaunchButton
            description="Je pré-remplis la fiche à partir de quelques mots"
            icon={faWandMagicSparkles}
            iconBackground="#0E5AA7"
            isCta
            onClick={() => onSelectMode("describe")}
            title="Décrire la situation"
          />

          {isPopulationPerimeter ? (
            <LaunchButton
              description="Choisir un risque depuis les suggestions du catalogue"
              icon={faMagnifyingGlass}
              onClick={() => onSelectMode("catalog")}
              title="Rechercher dans le catalogue"
            />
          ) : (
            <LaunchButton
              description="Créer la fiche à partir d'une photographie"
              icon={faCamera}
              onClick={() => onSelectMode("photo")}
              title="Ajouter une photographie"
            />
          )}
        </div>
      ) : (
        <div className="mt-20 flex flex-col gap-5">
          <TextInput
            rows={4}
            isFullWidth
            value={description}
            onChange={(event) => onDescriptionChange(event.value)}
            placeholder={descriptionPlaceholder}
            autoFocus
          />
        </div>
      )}
    </div>
  )
}
